import './App.css';
import './view/styles/variables.css'
import Login from './view/pages/login/Login';
import Dashboard from './view/pages/dashboard/Dashboard';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { Routes } from './constants/routes';
import { getToken, getUserData, Permission, removeToken, removeUserData, UserData } from './api/authApi';
import { useState } from 'react';
import Campaigns from './view/pages/campaigns/Campaigns';
import Channels from './view/pages/channels/Channels';
import Media from './view/pages/media/Media';
import Players from './view/pages/players/Players';
import Reports from './view/pages/reports/Reports2';
import PlayerDetails from './view/pages/players/PlayerDetails';
import ChannelMedia from './view/pages/channels/ChannelMedia';
import PriorityList from './view/pages/priorityLists/PriorityLists';
import PriorityListMedia from './view/pages/priorityLists/PriorityListMedia';
import UsersList from './view/pages/users/UsersList';
import UserSettings from './view/pages/users/UserSettings';
import CurrentPlayList from './view/pages/playNow/playNowList';
import CurrentPlayListMedia from './view/pages/playNow/playNowListMedia';
import MosaicScreen from './view/pages/mosaicScreen/MosaicScreen';
import MosaicScreenList from './view/pages/mosaicScreen/MosaicScreenList';
import Settings from './view/pages/settings/Settings';
import UserSettingsNotification from './view/pages/users/UserSettingsNotification';
import { ChangeLogPage } from './view/pages/changelog/Changelog';
import CampaignAndChannelAdhocReport from './view/pages/reports/CampaignAndChannelAdhocReport';
import MosaicAdhocReport from './view/pages/reports/MosaicAdhocReport';
import MosaicCampaignAndChannelReport from './view/pages/reports/MosaicCampaignAndChannelReport';
import PlayersMonitoring from './view/pages/playersMonitoring/PlayersMonitoring';
import TvGuide from './view/pages/tvGuid/TvGuide';
import ChannelPlaylist from './view/pages/channels/ChannelPlaylist';

function App() { 

  var currentToken = getToken();
  const [isAuthorized, setIsAuthorized] = useState<boolean>(!!currentToken); 
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false); 

  const toogleCollapse = () => setIsCollapsed(!isCollapsed);
  const logOut = () => {
    removeToken();
    removeUserData();
    setIsAuthorized(false);
  }

  const hasPermission = (userData: UserData, permission: Permission) => {
    return userData.permissions.findIndex(i => i == permission) !== -1;
}

const getDefaultRoute = () => {
    var userData = getUserData();
    if(hasPermission(userData, Permission.Dashboard)) { return Routes.Dashboard;}
    if(hasPermission(userData, Permission.PlayNowList)) return Routes.PlayNow;
    if(hasPermission(userData, Permission.PriorityList)) return Routes.PriorityList;

    return Routes.Reports;
  }


  if(!isAuthorized){
    return <BrowserRouter>
            <Route path={Routes.Login}>
                  <Login setIsAuthorized={setIsAuthorized}/>
            </Route>
            <Route path="*">
                <Redirect to={Routes.Login} />
            </Route>    
      </BrowserRouter>
  }

 
  return (
    <BrowserRouter>
        <Switch>
            <Route path={Routes.Login}>                
                <Login setIsAuthorized={setIsAuthorized} />
            </Route>
            <Route path={Routes.Dashboard}>
                <Dashboard logOut={logOut} toogleCollapse={toogleCollapse} isCollapsed={isCollapsed}/>
            </Route>
            <Route path={Routes.Media}>
                <Media logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path={Routes.Campaigns}>
                <Campaigns logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route exact path={Routes.Channels}>
                <Channels logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path={`${Routes.ChannelMedia}/nested-playlists/:nestedPlayListsId/days-statistic`}>
                <ChannelPlaylist logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path={Routes.ChannelMedia}>
                <ChannelMedia logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route exact path={Routes.Reports}>
                <Reports logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path={Routes.ReportsAdhoc}>
                <CampaignAndChannelAdhocReport logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path={`${Routes.ReportsSkin}/:skinId?`}>
                <MosaicCampaignAndChannelReport logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path={Routes.ReportsSkinAdhoc}>
                <MosaicAdhocReport logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route> 
            <Route exact path={Routes.PriorityList}>
                <PriorityList logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path={Routes.PriorityListMedia}>
                <PriorityListMedia logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route exact path={Routes.PlayNow}>
                <CurrentPlayList logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
             <Route path={Routes.PlayNowMedia}>
                <CurrentPlayListMedia logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route exact path={Routes.UserNotifications}>
                <UserSettingsNotification logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path={Routes.Users}>
                <UsersList logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path={Routes.UserSettings}>
                <UserSettings logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route exact path={Routes.Players}>
                <Players logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path={Routes.PlayerDetails}>
                <PlayerDetails logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route exact path={Routes.Skins}>
                <MosaicScreenList logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path={`${Routes.SkinDetails}`}>
                <MosaicScreen logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path={`${Routes.Settings}`}>
                <Settings logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path={`${Routes.PlayersMonitoring}`}>
                <PlayersMonitoring logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path={`${Routes.TvGuide}`}>
                <TvGuide logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path={`${Routes.ChangeLog}`}>
                <ChangeLogPage logOut={logOut} toogleCollapse={toogleCollapse}  isCollapsed={isCollapsed}/>
            </Route>
            <Route path="*">
                <Redirect to={getDefaultRoute()} />
            </Route>
        </Switch>
    </BrowserRouter >
  );
}

export default App;
